import { Component, Input, OnInit } from '@angular/core';
import { DisplayableColumns, DocumentsViewMode, DocumentsViewSettings } from '../../view-settings/viewSettings';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-settings-modal',
  templateUrl: './view-settings-modal.component.html',
  styles: []
})
export class ViewSettingsModalComponent implements OnInit {
  protected readonly DocumentsViewMode = DocumentsViewMode;
  @Input({ required: true }) viewSettings!: DocumentsViewSettings;
  viewMode = new FormControl<DocumentsViewMode>(DocumentsViewMode.card);

  constructor(public readonly modal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.viewMode.setValue(this.viewSettings.getViewMode());
  }

  columnsChanged(columns: DisplayableColumns) {
    this.viewSettings.updateColumns(columns);
  }

  updateViewMode(): void {
    this.viewSettings.updateViewMode(this.viewMode.value as DocumentsViewMode);
  }
}
